import { useQuery } from "@tanstack/react-query";
export const createJudgingProgrammeJudgesQueries = (requests, queryClient) => ({
    useListJudgingProgrammeJudges: (params, options = {}) => useQuery({
        queryKey: ["judging-programme-judges", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listJudgingProgrammeJudges(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map